export enum PlatformType {
  Android = 'android',
  Ios = 'ios'
}

export enum DebounceTimeType {
  ForCrashes = 10,
  InputChanges = 100,
  Long = 200
}
